import api from './api';

export const getEntrancesApi = params => {
  return api.get('/entrance', {params});
};

export const getEntrancesByBuildingApi = (buildingId, params) => {
  return api.get(`/entrance/building/${buildingId}`, {params});
};

export const getEntranceByIdApi = id => {
  return api.get(`/entrance/${id}`);
};

export const addEntranceApi = params => {
  return api.post('/entrance', params);
};

export const editEntranceApi = params => {
  return api.put('/entrance', params);
};

export const deleteEntranceApi = id => {
  return api.delete(`/entrance/${id}`);
};
